// extracted by mini-css-extract-plugin
export default {"wrapper":"uHIzlMs_TwUo3eflTr4v"};